import { useStore, useStoreMap, useGate } from 'effector-react'
import { Form, employeeModel } from '~/entities/Employee'
import { usePermissions } from '~/entities/viewer'
import { Role } from '~/shared/api'
import { timezoneCodeLabels } from '~/shared/config/constants'
import { formSubmitted, Gate, $employee, employeeUpdateFx } from './model'

type EditEmployeeProps = {
  employeeId: string
  canUpdate?: boolean
}

export function EditEmployee({
  employeeId,
  canUpdate = true,
}: EditEmployeeProps) {
  useGate(Gate, { employeeId })
  const { canUsersUpdate } = usePermissions()

  const isLoading = useStore(employeeModel.requestFx.pending)
  const isSaving = useStore(employeeUpdateFx.pending)

  const defaultValues = useStoreMap($employee, (employee) => {
    const timezone = employee?.getTimezone()
    return {
      ...employee?.getAttributes(),
      rolesIds: employee?.getRoles()?.map((role: Role) => role.getOption()),
      timezone: timezone
        ? {
            id: timezone,
            label: timezoneCodeLabels[timezone],
          }
        : null,
    }
  })

  return (
    <Form
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSuccess={formSubmitted}
      isSubmitting={isSaving}
      canEdit={canUsersUpdate && canUpdate}
    />
  )
}
